import { Image } from 'foundations-components/transitional/components/Image';
import { HubSpotProduct } from '../data/productsUsed';
import { getImageUrl } from '../../../utils/imageUrl';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const getIconUrl = name => getImageUrl(`icons/${name}`);
const ProductIcon = ({
  product
}) => {
  let src;
  if (product === HubSpotProduct.CMS_HUB || product === HubSpotProduct.CONTENT_HUB) {
    src = getIconUrl('icon-cms-hub.svg');
  } else if (product === HubSpotProduct.COMMERCE_HUB) {
    src = getIconUrl('icon-commerce-hub.svg');
  } else if (product === HubSpotProduct.MARKETING_HUB) {
    src = getIconUrl('icon-marketing-hub.svg');
  } else if (product === HubSpotProduct.OPS_HUB) {
    src = getIconUrl('icon-operations-hub.svg');
  } else if (product === HubSpotProduct.SALES_HUB) {
    src = getIconUrl('icon-sales-hub.svg');
  } else if (product === HubSpotProduct.SERVICE_HUB) {
    src = getIconUrl('icon-service-hub.svg');
  }
  if (src) {
    return /*#__PURE__*/_jsx(Image, {
      alt: "",
      inlineSize: "28px",
      src: src
    });
  }
  return /*#__PURE__*/_jsx(SprocketIcon, {
    size: "700"
  });
};
export default ProductIcon;